import { CurrentEnvironment } from '../getCurrentEnvironment'

export const getApiEndpoint = (environment: CurrentEnvironment) => {
  if (environment.development && process.env.REACT_APP_API_URL) {
    return process.env.REACT_APP_API_URL
  }

  if (typeof window !== 'undefined' && window.location && window.location.origin) {
    return window.location.origin
  }

  return 'https://cruscotto.idbgroup.it'
}
